import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/Services/loader.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { WebsiteService } from 'src/app/Services/website.service';
import { appConfig } from 'src/app/app.config';
import { AdminService } from 'src/app/Services/admin.service';


@Component({
  selector: 'app-budget-center',
  templateUrl: './budget-center.component.html',
  styleUrls: ['./budget-center.component.css']
})
export class BudgetCenterComponent implements OnInit {

  base_address: string = appConfig.apiUrl + 'admin/';
  quarter:Number = 1;
  year:Number = 2019;
  baseYear=0;
  baseQuarter=0;
  bcs:any;
  filteredBcs:any;
  selectedBc:any = {};
  searchText = '';

  tableData:any;
  mandatoryData:any;
  specificData:any;
  filteredData:any;
  outputList:any;

  yearsList:any;

  selectedOutput:Number = 0;

  constructor(private loader: LoaderService,
    private route: ActivatedRoute,
    private websiteser: WebsiteService,
    private adminService: AdminService,
    private toastr: ToastrService,
    private router: Router) { }

  ngOnInit() {
    setTimeout(() => {
      this.loader.hideLoader();
    }, 300);
    this.adminService.LoadYearsList().subscribe((data:any) => {
      console.log(data);
      this.yearsList = data.result;
      this.year = (new Date()).getFullYear();
      this.quarter = Math.floor(((new Date()).getMonth() +1) / 4)+1;
      console.log(this.quarter);
      this.bcs = this.route.snapshot.data.data.result;
      this.filteredBcs = this.bcs;
      this.selectedBc = this.bcs[0];
      this.getResults();
      });
    this.adminService.GetActiveGpwOutputs().subscribe((data:any) => {
      console.log(data);
      this.outputList = data.result;
      this.outputList.forEach(x=>{
        if(x.gpwoutput.length>150)
        x.gpwoutput=x.gpwoutput.substring(0,150)+'...';
        });
    });

  }

  selectBc(id){
    this.loader.showLoader();
    this.selectedBc = this.bcs.filter((item) => item.id == id)[0];
    this.getResults();
  }

  getResults(){
    this.websiteser.GetBcKpiResults(this.selectedBc.id, this.year, this.quarter, this.selectedOutput).subscribe((data:any) => {
      console.log(data.result);
      this.tableData = data.result.budgetCenterKpiTreeItems;
      this.baseYear = data.result.baseYear;
      this.baseQuarter = data.result.baseQuarter;
      this.mandatoryData = this.tableData.filter((item)=> item.isMandatory);
      this.specificData = this.tableData.filter((item)=> !item.isMandatory);
      this.loader.hideLoader();
    })
  }

  getArrow(first, second){
    let html = '<img src="';
    if(second == -1 || first == -1){
      return html += 'assets/imgs/right.png">'
    }
    if(second < first){
      return html += 'assets/imgs/up.png">'
    }
    else if(second > first){
      return html += 'assets/imgs/down.png">'
    }
    else{
      return html += 'assets/imgs/right.png">'
    }
  }

  searchTextchanged()
  {
    console.log(this.searchText);
    if(this.searchText.length == 0)
    {
      this.filteredBcs = this.bcs;
    }
    else{
      this.filteredBcs = this.bcs.filter(x=>x.value.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
    }
  }

}
